const View = ({ properties }) => <h1>{properties.title}</h1>;

export default View;
